































import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import FormatMoney from "@/components/FormatMoney";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationFundraisingRewardPurchased",
  components: { FormatMoney, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
});
